/*
 --------------------
 VIDEO PLAYER - OUTSTREAM
 --------------------

 A single instance of an Outstream Video Player. This player will only play Ads */

class outstreamVideoPlayer {
  constructor(options, manager) {

    this.manager = manager;

    this.accountID = typeof (options.accountID !== 'undefined')
      ? options.accountID
      : false;

    this.adserverUrl = typeof (options.adserverUrl !== 'undefined')
      ? options.adserverUrl
      : false;

    this.containerID = typeof (options.containerID !== 'undefined')
      ? options.containerID
      : false;

    this.muted = typeof (options.muted !== 'undefined')
      ? options.muted
      : false;

    this.callbackFunctions = typeof (options.callbackFunctions !== 'undefined')
      ? options.callbackFunctions
      : [];

    if(!Array.isArray(this.callbackFunctions)) {
      this.callbackFunctions = [this.callbackFunctions];
    }


    // Internal objects/flags
    this.player = {}; // BC player goes here
    this.ima3ScriptAvailable = false;
    this.adtechReady = false; // Set to true once header bidder has had chance to modify URL
    this.ixScriptAvailable = false;
    this.targetDiv = document.querySelector(this.containerID);
    this.initialised = false;
    this.endingAcknowledged = false;


    // Bind functions
    this.createPlayer = this.createPlayer.bind(this);
    this.fetchScripts = this.fetchScripts.bind(this);
    this.ima3FetchCallback = this.ima3FetchCallback.bind(this);
    this.ixFetchCallback = this.ixFetchCallback.bind(this);
    this.adtechReadyCallback = this.adtechReadyCallback.bind(this);
    this.modifyAdserverUrlWithTargeting = this.modifyAdserverUrlWithTargeting.bind(
      this
    );
    this.modifyAdserverUrlWithIxWrapper = this.modifyAdserverUrlWithIxWrapper.bind(
      this
    );
    this.allTechReadyGo = this.allTechReadyGo.bind(this);


    // Get this puppy runnin'
    this.fetchScripts();

  }



  fetchScripts() {
    const manager = this.manager;

    // Ensures BC script is properly fetched
    const bCScriptFetched = new Promise(resolve => {
      const identifier = "default" + this.accountID;
      const scriptFetched = manager.isScriptFetched(identifier);
      if (scriptFetched) {
        resolve();
      } else {
        manager.fetchBCScript(this.accountID, "default", resolve);
      }
    });

    const ixScriptFetched = manager.isScriptFetched('ix');
    if (ixScriptFetched) {
      this.ixFetchCallback();
    } else {
      manager.fetchIXScript(this.ixFetchCallback);
    }

    if (
      typeof window.AdManager !== 'undefined' &&
      typeof window.AdManager.callbackQueue !== 'undefined'
    ) {
      window.AdManager.queueCallback(this.adtechReadyCallback, true);
    }

    const that = this;

    bCScriptFetched.then(() => {
      console.log("PROMISE FULFILLED");
      // Give the wrapper 4000ms to init all required tech once bc script is fetched. If it's still not available, then trigger all queued callbacks
      setTimeout(() => {
        if (that.initialised === false) {
          that.adFinishedCallback();
          that.initialised = true;
        }
      }, 4000);
      const scriptFetched = manager.isScriptFetched('ima3');
      if (scriptFetched) {
        this.ima3FetchCallback();
      } else {
        manager.fetchIMA3Script(this.ima3FetchCallback);
      }
    });
  }

  /*
  =========================
  Adtech initialisation
  =========================
   */

  ixFetchCallback() {
    this.ixScriptAvailable = true;
    this.allTechReadyGo();
  }

  // Script to callback once IMA3 script is fetched. This will initialise the player
  ima3FetchCallback() {
    this.ima3ScriptAvailable = true; // Mark script as retrieved
    this.allTechReadyGo();
  }

  // Callback which fires when adtech has modified the adserver URL
  adtechReadyCallback() {
    if (!this.adtechReady) {
      this.modifyAdserverUrlWithTargeting();
    }
    this.adtechReady = true;
    this.allTechReadyGo();
  }

  allTechReadyGo() {
    if (this.initialised === true) return;
    if (this.adtechReady === false) return;
    if (this.ima3ScriptAvailable === false) return;
    if (this.ixScriptAvailable === false) return;
    this.modifyAdserverUrlWithIxWrapper();
    this.createPlayer();
  }

  modifyAdserverUrlWithTargeting() {
    if (typeof window.AdManager === 'undefined') return;

    const globalTargeting = window.AdManager.globalTargeting;
    // let adParams = '';
    let queryString = Object.keys(globalTargeting)
      .map(
        key =>
          `${encodeURIComponent(key)}%3D${encodeURIComponent(
            globalTargeting[key]
          )}`
      )
      .join('%26');

    if (queryString.length > 0) {
      queryString = `%26${queryString}`;
    }

    this.adserverUrl += queryString;
  }

  // Modifies the Adserver URL so that it is wrapped in IX Tags
  modifyAdserverUrlWithIxWrapper() {
    if (
      typeof window.getIndexTag === 'function' &&
      typeof window.indexConfig !== 'undefined'
    ) {
      this.adserverUrl = window.getIndexTag(
        this.adserverUrl,
        window.indexConfig
      );
    }
  }


  /*
  =========================
  Player initialisation
  =========================
   */

  // Creates a video player element within the container targetDiv
  // targetDiv must be an element (not an ID/class)
  createPlayer() {
    const targetDiv = this.targetDiv;
    this.initialised = true;
    const videoEl = document.createElement('video');
    videoEl.setAttribute("style", "width:inherit;height:inherit");
    videoEl.setAttribute("class", "video-js");
    videoEl.setAttribute("preload", "none");
    videoEl.setAttribute("controls", "");
    videoEl.setAttribute("playsinline", "");
    if(this.muted) {
      videoEl.setAttribute("muted", "");
    }

    // Insert the player into targetDiv
    targetDiv.appendChild(videoEl);

    this.player = window.bc(videoEl);
    this.player.addClass("vjs-ad-only");
    this.player.adonly = true;

    this.player.ima3({
      serverUrl: this.adserverUrl,
      timeout: 7500,
      requestMode: 'onload',
      adTechOrder: ["html5"],
    });

    this.player.on('ima3-ready', () => {
      this.player.play();
    });

    const that = this; // Because this is that and that is this
    const player = this.player;
    const manager = this.manager;

    player.on(["adend", "playing", 'ima3-ad-error', 'ads-ad-ended', 'ads-pod-ended'], function() {
      if(that.endingAcknowledged !== true) {
        player.pause(); // don't play the video ever
        setTimeout(function(){ // give IMA plugin some time to clean up and make sure all event beacons go out
          player.dispose();
          that.adFinishedCallback();
          manager.destroyPlayer(that.containerID.replace("#", ""), true);
        }, 200); // delay
        that.endingAcknowledged = true;
      }
    });

    player.src("//d2zihajmogu5jn.cloudfront.net/tiny.mp4"); // TODO - needs new dummy


  }


  /*
  =========================
  Event Callbacks
  =========================
   */

  adFinishedCallback() {
    this.callbackFunctions.forEach( callbackFunc => {
      callbackFunc();
    });
    console.log("Ad Finished/Failed Callback");
  }





}

export default (options, manager) => new outstreamVideoPlayer(options, manager);